export default "__VITE_ASSET__f161e6fd__"